import { config } from '@/config';
import { BaseService } from '@/services/base.service';
class AuthService extends BaseService {
    constructor() {
        super(...arguments);
        this.url = `${config.base_url}/api/auth`;
    }
    async authMobile(model) {
        const url = `${this.url}/authMobile`;
        return await this.post(model, url, 200);
    }
    async authOtp(model) {
        const url = `${this.url}/authOtp`;
        return await this.post(model, url, 200);
    }
}
export const authService = new AuthService();
//# sourceMappingURL=auth.service.js.map